export const ISLAND_CENTER = {
	latitude: 28.004708,
	longitude: -15.5
}


// WEBPACK FOOTER //
// ./src/config.js